import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class FacturasCredito extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'Ventas', saveUrl: 'Ventas/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
        Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 6, []),
        Form.Field('select', 'type', 'Reporte', '', [Validators.required], 6, 
        [
          { Label: 'Facturas sin Pagar', Value: '1' },
          { Label: 'Facturas Pagadas', Value: '2' },
        ]),
      ], ['Descargar Excel'], 'Reporte Pagos Contado'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    let newForm = form;
    let Res = await Http.get('reporte-cobranza/reporte/form');
    if (!Res.error) {
      newForm = Form.FieldOptions(form, 'id_sucursal', [{ id: 0, sucursal_nombre: 'Cualquiera' }, ...Res.data.sucursales], 'id', 'sucursal_nombre');
    }
    return newForm;
  }


  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate, id_sucursal, type } = vals;
    const start = moment(startDate).format('YYYY-MM-DD')
    const end = moment(endDate).format('YYYY-MM-DD')
    const Resp = await Http.get(`pago/reporte/pagos-reportes?q=1&report_type=4&start_date=${start}&end_date=${end}&id_sucursal=${id_sucursal}&type=${type}`, true, 'arraybuffer')
    if (Resp) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a');
      link.href = url;
      link.download = 'ConsecutivoFacturas.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(FacturasCredito)
